export const PRODUCT_MANAGEMENT_LIST_MENU = {
  SET_FILTERS:'PRODUCT_MANAGEMENT_LIST_MENU.SET_FILTERS',
  SET_INITIAL_STATE_MENU:'PRODUCT_MANAGEMENT_LIST_MENU.SET_INITIAL_STATE_MENU',
  SET_INITIAL_SITUATION: 'PRODUCT_MANAGEMENT_LIST_MENU.SET_INITIAL_SITUATION',
  SET_INITIAL_ACQUISITION_COST: 'PRODUCT_MANAGEMENT_LIST_MENU.SET_INITIAL_ACQUISITION_COST'
}